module.exports = __webpack_public_path__ + "img/history-honer.95438af7.png";